package com.appsyde.shared.presentation.screen.component.message.helper

import com.appsyde.shared.modules.ticket.domain.model.TicketRespondMessage
import kotlin.js.Date
import kotlin.text.RegexOption

fun formatSmartTime(sentAtMs: Long): String {
    val now = Date()
    val sent = Date(sentAtMs)

    fun two(n: Int) = n.toString().padStart(2, '0')

    val sameDay =
        now.getFullYear() == sent.getFullYear() &&
                now.getMonth() == sent.getMonth() &&
                now.getDate() == sent.getDate()

    if (sameDay) {
        val diffMs = now.getTime() - sent.getTime()
        val diffMin = (diffMs / 60000).toInt()

        return when {
            diffMin < 0 -> "${two(sent.getHours())}:${two(sent.getMinutes())}" // clock skew
            diffMin < 1 -> "à l'instant"
            diffMin < 60 -> "il y a $diffMin min"
            else -> "${two(sent.getHours())}:${two(sent.getMinutes())}"
        }
    }

    val month = when (sent.getMonth()) {
        0 -> "janv"
        1 -> "févr"
        2 -> "mars"
        3 -> "avr"
        4 -> "mai"
        5 -> "juin"
        6 -> "juil"
        7 -> "août"
        8 -> "sept"
        9 -> "oct"
        10 -> "nov"
        11 -> "déc"
        else -> ""
    }

    return "${sent.getDate()} $month · ${two(sent.getHours())}:${two(sent.getMinutes())}"
}

fun String.stripRolePrefixForSafety(): String {
    val s = trimStart()
    return s.replace(Regex("""^\[(Client|Vous|AI|Agent)\]\s*""", RegexOption.IGNORE_CASE), "")
}

fun TicketRespondMessage.bestBody(): String {
    return (originalBody ?: summary ?: bodyPreview ?: "—").stripRolePrefixForSafety()
}

fun String.initialOrFallback(): String {
    val s = trim()
    return s.firstOrNull()?.uppercaseChar()?.toString() ?: "C"
}

fun TicketRespondMessage.authorInitial(): String {
    val email = authorEmail?.trim().orEmpty()
    return if (email.isNotBlank()) email.initialOrFallback() else "C"
}

fun shouldShowSeparator(vararg parts: String?): Boolean {
    return parts.count { !it.isNullOrBlank() } >= 2
}
